import { createContext, useContext } from 'react';
/** @type {import('react').Context<{ menu?: import('reakit').MenuStateReturn }>} */

export var MenuContext = /*#__PURE__*/createContext({});
export var useMenuContext = function () {
  return useContext(MenuContext);
};